var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToolboxMap = function SvgToolboxMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.781 22.43V4.421c0-.147.085-.28.218-.341L8.21.753a.38.38 0 0 1 .314 0l7.346 3.39c.457.211.986.198 1.433-.034l5.365-2.8c.25-.13.548.051.548.333v17.93a.38.38 0 0 1-.213.339l-6.288 3.007a.38.38 0 0 1-.308.007L9.017 19.8a1.63 1.63 0 0 0-1.313.021l.262.568-.262-.568-6.39 2.95a.375.375 0 0 1-.533-.34ZM8.371.508v19.396M16.555 4.5v18"
  }))));
};
export default SvgToolboxMap;